export const NAVBAR = Symbol('navbar');
export const PAGE = Symbol('page');
export const FOOTER = Symbol('footer');
